// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from './Providers';
import App from './App';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppProviders>
      <div className="app-container">
        <div className="space-container">
          <div className="content-container">
            <App />
          </div>
        </div>
      </div>
    </AppProviders>
  </BrowserRouter>
);
